

// product js start

  $(document).ready(function(){
  
  const buttonGroup = $(".button-group-mb a");
  const formProduct = $(".c-card-product");
  const overplay = $(".PageOverlay");
  const pageOverlay = $(".PageOverlay");
  const iconClose = $(".c-card-product .icon.icon-close");
  const iconText = $(".c-text-close");
  buttonGroup.click(function() {
    $('body').addClass("lock-all");
    formProduct.addClass("is-showing-popup");
    overplay.addClass("is-visible");
  });
    
  iconClose.click(function() {
      $('body').removeClass("lock-all");
      formProduct.removeClass("is-showing-popup");
      overplay.removeClass("is-visible");
  });
    
  iconText.click(function() {
      $('body').removeClass("lock-all");
      formProduct.removeClass("is-showing-popup");
      overplay.removeClass("is-visible");
  });
    
  pageOverlay.click(function() {
      $('body').removeClass("lock-all");
      formProduct.removeClass("is-showing-popup");
      overplay.removeClass("is-visible");
  });
    // if( $('.template-page').hasClass('page--gender_women')){
    //    $( ".page--gender_women #rec_area_coordinate" ).append( "<div class=\"section__footer\"><a href=\"/apps/staffstart/coordinates?genre=2\" class=\"c-staffstart__viewmore staff-here c-blockImage__button button c-button__primary\">VIEW MORE</a></div>" );
 
    // }
    // else if($('.template-page').hasClass('page--gender_men')){
    //    $( ".page--gender_men #rec_area_coordinate" ).append( "<div class=\"section__footer\"><a href=\"/apps/staffstart/coordinates?genre=1\" class=\"c-staffstart__viewmore staff-here c-blockImage__button button c-button__primary\">VIEW MORE</a></div>" );
  
    // }else{
    //     $( "#rec_area_coordinate" ).append( "<div class=\"section__footer\"><a href=\"/apps/staffstart/coordinates\" class=\"c-staffstart__viewmore staff-here c-blockImage__button button c-button__primary\">VIEW MORE</a></div>" );

    // }
  function intervalFunc() {
    if($('.dIdfxQ .fJZQIc').length){
      if ($('.c-main-product .topbar-collection__link').hasClass('c-staff__women') || $('.template-page').hasClass('page--gender_women')) {
      $( ".c-main-product .staffstart-shopify-app-container .dIdfxQ" ).append( "<a href=\"/apps/staffstart/coordinates?genre=2\" class=\"c-staffstart__viewmore staff-here\">VIEW MORE</a>" );  
      
    }else if($('.c-main-product .topbar-collection__link').hasClass('c-staff__men') || $('.template-page').hasClass('page--gender_men')){
      $( ".c-main-product .staffstart-shopify-app-container .dIdfxQ" ).append( "<a href=\"/apps/staffstart/coordinates?genre=1\" class=\"c-staffstart__viewmore staff-here\">VIEW MORE</a>" );  
     }else{
      $( ".c-main-product .staffstart-shopify-app-container .dIdfxQ" ).append( "<a href=\"/apps/staffstart/coordinates\" class=\"c-staffstart__viewmore staff-here\">VIEW MORE</a>" );  
     }
    }
    
    var heightinfo = $(".c-main-product .product .product__info").height();
    var paramstaff = $(".c-staffstart__viewmore.staff-here");
    var stringinfo = heightinfo + "px";
    if (paramstaff.length > 0) {
        $(".c-main-product .product.c-product__staff-snap").addClass("staff-show");
        clearInterval(vary);
              // slick staff snap new\
        $('.c-main-product .product.staff-show .fBqgJH').on('init', function(event, slick) {
          var staffCount = slick.$slides.length - 1;
            if(staffCount == 1){
              $('.c-main-product .staffstart-shopify-app-container').addClass('hide--dot');
            }
        });
        if( $('.c-main-product .product.staff-show .fBqgJH .sc-koXPp').length > 4 && $(window).width() > 999 ){
             $('.c-main-product .product.staff-show .fBqgJH').slick({
          dots: false,
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          nextArrow: '<span class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13.023" height="7.183" viewBox="0 0 13.023 7.183"><g transform="translate(0 0.39)"><path d="M1420.62,231.5h11.691" transform="translate(-1420.62 -228.325)" fill="none" stroke="currentColor" stroke-width="1.1"/><path d="M1433.283,227.852l3.2,3.2-3.2,3.2" transform="translate(-1424.24 -227.853)" fill="none" stroke="currentColor" stroke-width="1.1"/></g></svg></span>',
          prevArrow: '<span class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13.023" height="7.183" viewBox="0 0 13.023 7.183"><g  transform="translate(0.778 0.388)"><path d="M1432.311,231.5H1420.62" transform="translate(-1420.066 -228.324)" fill="none" stroke="currentColor" stroke-width="1.1"/><path d="M1436.485,227.852l-3.2,3.2,3.2,3.2" transform="translate(-1433.283 -227.851)" fill="none" stroke="currentColor" stroke-width="1.1"/></g></svg></span>',
          responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              arrows: true,
              dots: false
            }
          },
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              arrows: false,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: false,
              arrows: false,
              dots: true
            }
          }
        ]
        });  
        }else if ($('.c-main-product .product.staff-show .fBqgJH .sc-koXPp').length > 2 && $(window).width() < 999){
           $('.c-main-product .product.staff-show .fBqgJH').slick({
          dots: false,
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          nextArrow: '<span class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13.023" height="7.183" viewBox="0 0 13.023 7.183"><g transform="translate(0 0.39)"><path d="M1420.62,231.5h11.691" transform="translate(-1420.62 -228.325)" fill="none" stroke="currentColor" stroke-width="1.1"/><path d="M1433.283,227.852l3.2,3.2-3.2,3.2" transform="translate(-1424.24 -227.853)" fill="none" stroke="currentColor" stroke-width="1.1"/></g></svg></span>',
          prevArrow: '<span class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13.023" height="7.183" viewBox="0 0 13.023 7.183"><g  transform="translate(0.778 0.388)"><path d="M1432.311,231.5H1420.62" transform="translate(-1420.066 -228.324)" fill="none" stroke="currentColor" stroke-width="1.1"/><path d="M1436.485,227.852l-3.2,3.2,3.2,3.2" transform="translate(-1433.283 -227.851)" fill="none" stroke="currentColor" stroke-width="1.1"/></g></svg></span>',
         }); 
        }
         

      
    }else{
        $(".c-main-product .product.c-product__staff-snap").removeClass("staff-show");
    }
  }
  vary = setInterval(intervalFunc, 5000);
});


